import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCArthur extends NPC {
    constructor() {
        super(definitions.NPC_ID.ARTHUR);

        this.collisionRadius = 25;
        this.collisionOffsetX = 8;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_arthur_wolf_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(8, -6));
        this.animateIdle(1);
    }

    onViewAdded() {
        super.onViewAdded();

        this._status.x += 18;
        this._status.y += 18;
    }
}